import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { playerApi } from '../../lib/api';

const Ctx = createContext(null);
export const usePlayer = () => useContext(Ctx);

export function PlayerProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);
  const [chars, setChars] = useState([]);
  const [authOpen, setAuthOpen] = useState(false);

  const refresh = useCallback(async () => {
    try { setUser(await playerApi.me()); } catch { setUser(null); }
    setChecked(true);
  }, []);

  useEffect(() => {
    playerApi.characters().then(setChars).catch(() => {});
    // Skip /me while returning from Google OAuth: AuthCallback exchanges the session first
    if (/(session_id|apple_code)=/.test(window.location.hash || '')) { setChecked(true); return; }
    refresh();
  }, [refresh]);

  const signedIn = (r) => { localStorage.setItem('titan.player', r.token); setUser(r.user); setAuthOpen(false); toast.success(`Benvenuto, ${r.user.name}!`); };
  const logout = async () => { await playerApi.logout().catch(() => {}); localStorage.removeItem('titan.player'); setUser(null); };
  const character = (user && chars.find((c) => c.id === user.selected_character)) || chars[0] || null;

  return <Ctx.Provider value={{ user, setUser, checked, chars, character, signedIn, logout, refresh, authOpen, setAuthOpen }}>{children}</Ctx.Provider>;
}

const APPLE_ERRORS = {
  annullato: 'Accesso con Apple annullato', negato: 'Apple non ha autorizzato l\'accesso', configurazione: 'Accesso con Apple non riuscito: configurazione Apple da verificare',
  verifica: 'Accesso con Apple non verificato: riprova', email: 'Apple non ha condiviso un\'email verificata: riprova consentendo l\'email',
  conflitto: 'Questa email è già collegata a un altro ID Apple',
};

export function AuthCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const { signedIn } = usePlayer();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const q = new URLSearchParams(hash.slice(1));
    const back = sessionStorage.getItem('titan.authReturn') || '/';
    const appleErr = q.get('apple_error');
    if (appleErr) { toast.error(APPLE_ERRORS[appleErr] || APPLE_ERRORS.verifica); nav(back, { replace: true }); return; }
    (q.get('apple_code') ? playerApi.apple(q.get('apple_code')) : playerApi.google(q.get('session_id'))).then((r) => { signedIn(r); nav(back, { replace: true }); })
      .catch((e) => { toast.error(e.message); nav(back, { replace: true }); });
  }, []); // eslint-disable-line
  return <div className="titan-root min-h-[100dvh] flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-violet-400" /></div>;
}
